import React from "react";
import {
  Filter,
  TextInput,
  ShowButton,
  // EditButton,
  List,
  DeleteButton,
  BooleanInput,
  FunctionField,
  Datagrid,
  TextField,
  Pagination,
  ReferenceField,
  DateField,
  Link,
  DateInput
} from "react-admin";
import { TextBooleanField } from "../components/TextBooleanField";
import Info from "@material-ui/icons/Info";

import { propEq, prop, filter, head, isEmpty } from "ramda";

import { stringify } from "querystring";
import moment from "moment";
import styled from "styled-components";

import GeneralPopOver from "../components/generalPopOver";

import { CustomBaseFilter } from "../components/selectboxfilter/customBaseFilter";

import CreateChargeButton from "../components/createCharge";

import TourBookingFormButton from "../components/tourBookingForm";
import ProfileCompleteMark from "../components/profileCompleteMark";
import { getPermissionRole } from "../util";
import Tooltip from "@material-ui/core/Tooltip";

const StyledDiv = styled.div(props => ({
  flexDirection: "column",
  alignItems: props.align ? props.align : "center",
  justifyContent: props.justify ? props.justify : "center",
  backgroundColor: props.color,
  paddingTop: props.padding ? props.padding : "0px",
  paddingBottom: props.padding ? props.padding : "0px",
  minHeight: "40px",
  display: "flex",
  minWidth: "100px"
}));

const ListPagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

// const EditTourButton = props => {
//   const reditectTo =
//     props.record.type === 1 ? "process_tour_edit" : "rental_clients";
//   return (
//     <EditButton
//       component={Link}
//       to={{
//         pathname: `/${reditectTo}/${props.record.id}`,
//         search: props.search
//       }}
//       label="Edit"
//     />
//   );
// };

function Fecha(date){
  return moment.utc(date).locale('es').format('YYYY-MM-DD');
}

const TourListFilter = props => (
  <Filter {...props}>
    <TextInput label="Tour rental Id" source="id" alwaysOn />
    <CustomBaseFilter label="Pick-up" source="location_id_1" alwaysOn />
    <TextInput label="Client Email" source="client_email" alwaysOn />
    <TextInput label="Client First Name" source="first_name" alwaysOn />
    <TextInput label="Client Last Name" source="last_name" alwaysOn />
    <DateInput label="Start date" source="date_begin" locales="es-Es" options={{ timeZone: 'UTC' }} alwaysOn />
    <BooleanInput label="Only paid" source="paid" alwaysOn />
  </Filter>
);

const rowStyle = (record, index) => ({
  backgroundColor: record.rental_status === 3 ? "#cccccc" : ""
});
let dayActual = moment(Date.now()).format("YYYY-MM-DD")
export const TourList = ({ permissions, ...props }) => (
  <List
    {...props}
    title="Booked Tours"
    resource="rentals"
    pagination={<ListPagination />}
    destroyOnUnmount={true}
    filters={<TourListFilter />}
    filter={{ type: 1, has_totals: 1, show_canceled: 1, show_all: 1 }}
    bulkActionButtons={false}
    sort={{ field: "date_1", order: "ASC" }}
    filterDefaultValues={{ date_begin: Date() }}
  >
    <Datagrid rowStyle={rowStyle}>
      <TextField label="Tour rental ID" source="id" />
      <DateField locales="es-Es" options={{ timeZone: 'Europe/Madrid' }} label="Pick-up" source="date_1" />

      <ReferenceField
        label="Client"
        source="booking_id"
        reference="bookings"
        linkType={false}
      >
        <FunctionField
          render={booking => {
            return (
              <Link
                to={{ pathname: `/clients/${booking.client_id}` }}
                target="_blank"
              >{`${booking.r_first_name} ${booking.r_last_name}`}</Link>
            );
          }}
        />
      </ReferenceField>

      <ReferenceField
        label="Base Location"
        source="location_id_1"
        reference="locations"
        linkType={false}
      >
        <FunctionField
          label="Base"
          addLabel={false}
          render={location => {
            return (
              <StyledDiv color={location.color}>
                {location.location_name}
              </StyledDiv>
            );
          }}
        />
      </ReferenceField>

      <ReferenceField
        label="Destination"
        source="location_id_2"
        reference="locations"
        linkType={false}
      >
        <FunctionField
          label="Base"
          addLabel={false}
          render={location => {
            return (
              <StyledDiv color={location.color}>
                {location.location_name}
              </StyledDiv>
            );
          }}
        />
      </ReferenceField>

      <ReferenceField
        label="Submitted"
        source="booking_id"
        reference="bookings"
        linkType={false}
      >
        <DateField source="r_timestamp" />
      </ReferenceField>

      <FunctionField
        label="Days Left"
        addLabel={false}
        render={rental => {
          return moment(rental.date_1).diff(dayActual, "days");
        }}
      />
      <ReferenceField
        label="P4M"
        source="booking_id"
        reference="bookings"
        linkType={false}
      >
        <TextBooleanField label="P4M" source="p4m" />
      </ReferenceField>

      <ReferenceField
        label="Tour"
        source="booking_id"
        reference="bookings"
        linkType={false}
      >
        <ReferenceField source="tour_id" reference="tours" linkType={false}>
          <ReferenceField
            source="tour_name_id"
            reference="tour_names"
            linkType={false}
          >
            <TextField source="tour_name_en" />
          </ReferenceField>
        </ReferenceField>
      </ReferenceField>
      {/* <BooleanField label="From Agency" source="from_agency" /> */}

      <FunctionField
        addLabel={false}
        render={rental => {
          return (
            <ShowButton
              to={{
                pathname: `/tour_clients/${rental.id}/show`,
                search: '?from=tour_list'
              }}
              search={stringify({ from: props.resource })}
              record={rental}
              label="View"
            />
          );
        }}
      />

      {/* {([1, 2, 4, 6, 9].includes(getPermissionRole())) && (
        <FunctionField
          addLabel={false}
          render={rental => {
            if (rental.rental_status !== 3) {
              return <CreateChargeButton rental={rental} extraCharge={true} />;
            }
            return "";
          }}
        />
      )} */}
      <FunctionField
        addLabel={false}
        render={rental => {
          return <TourBookingFormButton bookingId={rental.booking_id} />;
        }}
      />

      <FunctionField
        addLabel={false}
        render={rental => <ProfileCompleteMark record={rental} />}
      />

      <FunctionField
        addLabel={false}
        render={rental => {
          if (moment(rental.date_2).diff(dayActual, "days") > 0) {
            if (!isEmpty(rental.payments)) {
              const pendingCharges = filter(
                propEq("status", false),
                prop("charges", head(rental.payments))
              );

              if (isEmpty(pendingCharges)) {
                if (rental.rental_status !== 3 && [1, 2, 4, 6, 9].includes(getPermissionRole())) {
                  return (
                    <React.Fragment>
                      <Tooltip title="Cancel">
                        <span>
                          <DeleteButton
                            basePath="tour_list"
                            redirect="tour_list"
                            resource="rentals"
                            label=""
                            record={rental}
                            disabled={rental.rental_status === 3 ? true : false}
                            undoable={false}
                          />
                        </span>
                      </Tooltip>
                    </React.Fragment>
                  );
                } else {
                  // return (
                  //   <ShowButton
                  //     to={{
                  //       pathname: `/tour_clients/${rental.id}/show`
                  //     }}
                  //     search={stringify({ from: props.resource })}
                  //     record={rental}
                  //     label="View"
                  //   />
                  // );
                }
              } else {
                return (
                  <GeneralPopOver
                    itemText="Pending Charges. Please Reload List. For more info check Details - Payments"
                    iconImage={Info}
                  />
                );
              }
            }
          } else {
            return "";
          }
        }}
      />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/resources/tour_list.js